import anime from 'animejs'
export default defineNuxtPlugin(() => {
  const particle = (type, origin, destination, volume = 5, duration = 1000) => {
    const originEl = document.querySelectorAll(`[particle=${origin}]`)[0]
    const destinationEl = document.querySelectorAll(
      `[particle=${destination}]`,
    )[0]

    if (!originEl || !destinationEl) {
      throw new Error('Needs destination and origin elements')
    }

    const delayConst = 100
    const originTop = originEl.offsetTop + originEl.offsetHeight / 2
    const originLeft = originEl.offsetLeft + originEl.offsetWidth / 2
    const destinationTop =
      destinationEl.offsetTop + destinationEl.offsetHeight / 2
    const destinationLeft =
      destinationEl.offsetLeft + destinationEl.offsetWidth / 2
    const coins = ref()
    try {
      coins.value = [...Array(volume).keys()].map(() => {
        const coin = document.createElement('div')
        coin.classList.add(`particle-${type}`)
        coin.style.top = `${originTop - 20}px`
        coin.style.left = `${originLeft - 20}px`
        return coin
      })
    } catch {}

    coins.value.forEach((element) => {
      document.body.append(element.cloneNode(true))
    })

    const appendedCoins = document.querySelectorAll(`.particle-${type}`)

    appendedCoins.forEach((coin, index) => {
      anime({
        targets: coin,
        easing: 'easeInOutExpo',
        opacity: [1, 0.5, 0],
        translateX: destinationLeft - originLeft,
        translateY: destinationTop - originTop,
        delay: index * delayConst,
        duration,
        complete() {
          coin.remove()
        },
      })
    })
  }

  return {
    provide: {
      particle,
    },
  }
})
